<template>
  <div>
    <!-- Title Page -->
    <section
      class="bg-title-page flex-c-m p-t-160 p-b-80 p-l-15 p-r-15"
      style="background-image: url(/../static/images/bg-title-page-02.jpg);"
    >
      <h2 class="tit6 t-center">在地人帶你去</h2>
    </section>

    <!-- Gallery -->
    <div class="section-gallery p-t-118">
      <div
        class="wrap-label-gallery filter-tope-group size27 flex-w flex-sb-m m-l-r-auto flex-col-c-sm p-l-15 p-r-15 m-b-60"
      >
        <button class="label-gallery txt26 trans-0-4 is-actived" @click="filterType()">總覽</button>

        <button class="label-gallery txt26 trans-0-4" @click="filterType('food')">吃吃喝喝</button>

        <button class="label-gallery txt26 trans-0-4" @click="filterType('story')">過去的故事</button>

        <button class="label-gallery txt26 trans-0-4" @click="filterType('events')">遊山玩水</button>
      </div>

      <div class="wrap-gallery isotope-grid-gallery flex-w">
        <div
          v-for=" (galleryEachInfo,index) in configGalleryData"
          class="item-gallery isotope-item bo-rad-10 hov-img-zoom"
          v-bind:class="galleryEachInfo.type"
          v-if=" (index+1) > ((currentPage-1) * pageSize) && (index+1) <= ((currentPage) * pageSize)"
          style="height: 100%;"
        >
          <img :src="galleryEachInfo.galleryImage" >
          <!-- for test -->
          <!-- <img :src="'../static/images/bg-title-page-02.jpg'"> -->
          <div class="overlay-item-gallery trans-0-4 flex-c-m">
            <router-link
              :to="galleryEachInfo.routeName"
              class="btn-show-gallery flex-c-m"
              style="text-decoration:none;"
            >
              <span style="padding-left: 12px;">
                {{galleryEachInfo.galleryName}}
                <i style="padding-left: 12px;" class="fa fa-search"></i>
              </span>
            </router-link>
          </div>
        </div>
        <!-- </div> -->
      </div>

      <div class="pagination flex-c-m flex-w p-l-15 p-r-15 m-t-24 m-b-50">
        <!-- <a href="#" class="item-pagination flex-c-m trans-0-4 active-pagination" >1</a>
        <a href="#" class="item-pagination flex-c-m trans-0-4">2</a>-->
        <el-pagination
          layout="pager"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<style scoped>
div[data-filter="food"] {
  background: yellow;
}
div[data-filter="story"] {
  background: red;
}
div[data-filter="events"] {
  background: blue;
}
button:focus[data-filter] {
  opacity: 0.8;
  outline: none;
}

button[data-filter="food"]:focus ~ div:not([data-filter="food"]) {
  height: 0px;
  width: 0px;
  border: none;
  margin: 0;
  display: none;
}

button[data-filter="story"]:focus ~ div:not([data-filter="story"]) {
  height: 0px;
  width: 0px;
  border: none;
  margin: 0;
  display: none;
}

button[data-filter="events"]:focus ~ div:not([data-filter="events"]) {
  height: 0px;
  width: 0px;
  border: none;
  margin: 0;
  display: none;
}
.overlay-item-gallery {
  background-color: rgba(255, 187, 0, 0.8);
}
.pagination {
  display: flex;
}
.btn-show-gallery {
  width: 60%;
  height: 30%;
  border-radius: 30px;
}

.pagination >>> .el-pager li {
  padding: 0 4px;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 35px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 13px;
  color: #808080;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e6e6e6;
  margin: 6px;
  text-align: center;
}
.pagination >>> .el-pager  li.active {
  background-color: #333333;
  color: white;
}
</style>
<script >
export default {
  name: "Gallery",
  data() {
    return {
      configGalleryData: [],
      configGalleryCacheData: [],
      total: 0,
      pageSize: 2,
      currentPage: 1
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      window.scrollTo(0, 300);
      this.$forceUpdate();
    },
    filterType(type) {
      this.currentPage = 1;
      this.configGalleryData = [];
      for (let i = 0; i < this.configGalleryCacheData.length; i++) {
        if (type && this.configGalleryCacheData[i].type != type) {
          continue;
        } else {
          this.configGalleryData.push(this.configGalleryCacheData[i]);
        }
      }
      if (
        this.configGalleryData.length % (this.pageSize * this.currentPage) >=
        1
      ) {
        this.total =
          this.pageSize *
            Math.floor(this.configGalleryData.length / this.pageSize) +
          this.pageSize;
      } else if (
        this.configGalleryData.length % (this.pageSize * this.currentPage) ==
        0
      ) {
        this.total =
          this.configGalleryData.length / (this.pageSize * this.currentPage);
      }
      this.$forceUpdate();
    }
  },
  created() {
    let self = this;
    const p = new Promise((resolve, reject) => {
      let data = [];
      const readGalleryInfo = firebaseDB.ref("galleries");
      readGalleryInfo
        .orderByChild("galleryName")
        .on("value", function(snapshot) {
          snapshot.forEach(function(childSnapshot) {
            data.push(childSnapshot.val());
          });
          resolve(data);
        });
    }).then(data => {
      self.configGalleryCacheData = data;
      self.configGalleryData = data;
      if (data.length % (self.pageSize * self.currentPage) >= 1) {
        self.total =
          self.pageSize *
            Math.floor(self.configGalleryData.length / self.pageSize) +
          self.pageSize;
      } else if (data.length % (self.pageSize * self.currentPage) == 0) {
        self.total =
          (self.configGalleryData.length / (self.pageSize * self.currentPage))*self.pageSize;
      }
      this.$forceUpdate();
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Gallery.vue